import { render } from "./ImageCollage.vue?vue&type=template&id=450212a1&scoped=true"
import script from "./ImageCollage.vue?vue&type=script&lang=js"
export * from "./ImageCollage.vue?vue&type=script&lang=js"

import "./ImageCollage.vue?vue&type=style&index=0&id=450212a1&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-450212a1"]])

export default __exports__